import React, { useState } from "react";
import ModalComponent from "../../../../../biblio/Modal/ModalComponent";
import { Col, Form, Row } from "antd";
import Inputs from "../../../../../biblio/Inputs/Inputs";
import PrimaryButton from "../../../../../biblio/Buttons/PrimaryButton";
import MoyasarForm from "../../../../../components/Moyasar/MoyasarForm";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../../apis/store";
import {
  resetMoyasar,
  setIsSponsorshipPay,
  setMobile,
} from "../../../../../apis/slices/moyasarSlice";

interface AddWalletAmountProps {
  isWalletModalVisible: boolean;
  setIsWalletModalVisible: (value: boolean) => void;
}

const AddWalletAmount = ({
  isWalletModalVisible,
  setIsWalletModalVisible,
}: AddWalletAmountProps) => {
  const dispatch = useDispatch<AppDispatch>();
  const sponsor = useSelector(
    (state: RootState) => state?.sponsor?.sponsorDetails
  );
  const [form] = Form.useForm();
  const [displayMoyasar, setDisplayMoyasar] = useState<boolean>(false);

  const handleAddToWallet = async () => {
    try {
      await form.validateFields();
      setDisplayMoyasar(true);
      dispatch(setIsSponsorshipPay(true));
      dispatch(setMobile(sponsor?.mobile));
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <ModalComponent
        title=""
        open={isWalletModalVisible}
        onClose={() => {
          setIsWalletModalVisible(false);
          dispatch(resetMoyasar());
          form.resetFields();
        }}
        closeOnOutsideClick={true}
        width={500}
        modalStyle={{ top: 200 }}
      >
        <Form form={form} layout="vertical">
          <Row justify={"center"}>
            <p className="takaful--confirm-logout">إضافة مبلغ في المحفظة</p>
          </Row>
          <Row
            gutter={16}
            justify={"center"}
            style={{ paddingTop: "2rem" }}
            className={`takaful--content-profile-box1 takaful--content-select`}
          >
            <Col span={24} className="takaful--content-profile-col">
              <Form.Item
                name="amount"
                label="المبلغ :"
                layout="horizontal"
                wrapperCol={{
                  xxl: 19,
                  xl: 19,
                  lg: 19,
                  md: 19,
                  sm: 19,
                  xs: 19,
                }}
                labelAlign="left"
                labelCol={{
                  className: "takaful--label-style",
                  xxl: 5,
                  xl: 5,
                  lg: 5,
                  md: 5,
                  sm: 5,
                  xs: 5,
                }}
                rules={[
                  {
                    required: true,
                    message: "الرجاء تعبئة الحقل",
                  },
                  {
                    validator: (_, value) => {
                      if (!value || parseFloat(value) >= 5) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error("الحد الأدنى للمبلغ هو 5")
                      );
                    },
                  },
                ]}
              >
                <Inputs type="tel" maxLength={10} />
              </Form.Item>
            </Col>
          </Row>
          <Row justify={"end"} dir="rtl" style={{ width: "100%" }}>
            <Col xxl={6} xl={6} lg={6} md={6} sm={9} xs={9}>
              <PrimaryButton
                style={{ width: "100%" }}
                onClick={() => {
                  handleAddToWallet();
                }}
                title="سداد"
              />
            </Col>
          </Row>
        </Form>
      </ModalComponent>

      <MoyasarForm
        amount={form.getFieldValue("amount")}
        description="Takaful"
        open={displayMoyasar}
        handleClose={() => {
          setDisplayMoyasar(false);
          dispatch(resetMoyasar());
        }}
      />
    </>
  );
};

export default AddWalletAmount;
